import { Module } from "vuex";
import { RootState } from "@/services/store/root-state";
import { IMatchingSearchState } from "@/modules/matching/services/store/matching-search/matching-search.types";
import { mutations } from "@/modules/matching/services/store/matching-search/matching-search.mutations";
import { getters } from "@/modules/matching/services/store/matching-search/matching-search.getters";
import { actions } from "@/modules/matching/services/store/matching-search/matching-search.actions";

export const state: IMatchingSearchState = {
  loading: false,
  loadingFacet: false,
  error: null,
  results: [],
  hit_count: 0,
  facets: {
    sectors: { facet: "sectors", options: [] },
    regions: { facet: "regions", options: [] },
    countries: { facet: "countries", options: [] },
    founding_date: { facet: "founding_date", options: [] },
  },
  page: 1,
  per_page: 30,
  filters: {
    vil: [1, 6],
    sort: "desc",
    query: "",
    action: "search",
    sectors: [],
    countries: [],
    founding_date: [],
    sectorsFacetQuery: "",
    countriesFacetQuery: "",
    foundingDateFacetQuery: "",
  },
};

export const matchingSearchModule: Module<IMatchingSearchState, RootState> = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
